import { ImageScaleView, ImageScaleViewOpts } from '@play-co/timestep-core/ui';
import { createUIPet } from 'src/game/pet/pet.utils';
import i18n from 'src/lib/i18n/i18n';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

export class OutOfCoins extends ImageScaleView {
  constructor(opts: ImageScaleViewOpts) {
    super({
      ...opts,
      width: 588,
      height: 151,
      centerOnOrigin: true,
      image: 'assets/ui/shared/frames/backdrop_panel.png',
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 50, right: 50 },
        vertical: { top: 50, bottom: 50 },
      },
    });

    const pet = createUIPet('sad');
    pet.updateOpts({
      superview: this,
      centerOnOrigin: true,
      x: this.style.width / 2,
      y: -40,
    });

    new LangBitmapFontTextView({
      superview: this,
      width: this.style.width - 60,
      height: 36,
      size: 30,
      color: '#CF1010',
      align: 'center',
      verticalAlign: 'center',
      localeText: () => i18n('puzzleCoins.notEnoughBPoints.title'),
      centerOnOrigin: true,
      font: 'Body',
      x: this.style.width / 2,
      y: 60,
    });

    new LangBitmapFontTextView({
      superview: this,
      width: this.style.width - 60,
      height: 36,
      size: 26,
      color: '#91808C',
      align: 'center',
      verticalAlign: 'center',
      localeText: () => i18n('puzzleCoins.notEnoughBPoints.message'),
      centerOnOrigin: true,
      font: 'Body',
      x: this.style.width / 2,
      y: 100,
    });
  }
}
